// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {AddLeadingZeroPipe} from "../../../../../shared/shared-pipes/add-leading-zero.pipe";
import {Translations} from "@translations";
import {TranslateService} from "@ngx-translate/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";

export interface DialogData_DurationDialogInput extends MatDialogDataBaseInput {
	startTime: Date | string;
	selectedHour?: number;
	selectedMin?: number;
}

export interface DialogData_DurationDialogOutput extends MatDialogDataBaseOutput {
	selectedDuration?: {hour: number; min: number};
}

@Component({
	selector: "sim-duration-dialog",
	templateUrl: "./duration-dialog.component.html",
	styleUrls: ["./duration-dialog.component.scss"],
	standalone: false,
})
export class DurationDialogComponent
	extends BasicMaterialDialog<DurationDialogComponent, DialogData_DurationDialogInput, DialogData_DurationDialogOutput>
	implements OnInit
{
	T = Translations;

	suggestions = [
		{hour: 0, min: 15},
		{hour: 0, min: 30},
		{hour: 0, min: 45},
		{hour: 1, min: 0},
		{hour: 1, min: 15},
	];

	public duration = new FormGroup({
		hour: new FormControl(this.data?.selectedHour ? this.addLeadingZero(this.data.selectedHour).toString() : "", [
			Validators.min(0),
			Validators.max(23),
		]),
		min: new FormControl(this.data?.selectedMin ? this.data.selectedMin.toString() : "", [Validators.min(0), Validators.max(59)]),
	});

	constructor(
		_injector: Injector,
		private _addLeadingZeroPipe: AddLeadingZeroPipe,
		public translate: TranslateService,
	) {
		super(_injector);
	}

	setDuration(suggestion: {min: number; hour: number}) {
		const hourFormat = suggestion.hour.toString().padStart(2, "0");
		const minFormat = suggestion.min.toString().padStart(2, "0");

		this.duration.setValue({min: minFormat, hour: hourFormat});
	}

	addLeadingZero(number) {
		if (number <= 9) {
			return "0" + number;
		} else {
			return number + "";
		}
	}

	ok() {
		const hour = parseInt(this.duration.controls.hour.value) || 0;
		const min = parseInt(this.duration.controls.min.value) || 15;
		this.close({action: "ok", selectedDuration: {hour: hour, min: min}});
	}
}
